import * as React from 'react';
import { InactiveAnnouncementsLink, TDealType } from '../../components/InactiveAnnouncementsLink';

export interface IProlongationPopupMultipleContentProps {
  operationType: string;
}

export const ProlongationPopupMultipleContent: React.FC<IProlongationPopupMultipleContentProps> = ({
  operationType,
}) => (
  <div>
    <span>Срок публикации некоторых объявлений истек.</span>
    <br />
    <span>
      Для восстановления объявления пройдите по{' '}
      <InactiveAnnouncementsLink dealType={operationType.toLowerCase() as TDealType} target="_blank">
        ссылке
      </InactiveAnnouncementsLink>
    </span>
  </div>
);
